<template>
  <div>
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-select v-model="params.business_id" clearable filterable placeholder="Business" size="small">
          <el-option v-for="business in businesses" :key="business.id" :value="business.id"
            :label="business.country + ' / ' + business.name" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openAdd">Add</el-button>
      </el-form-item>
    </el-form>
    <el-table size="small" :data="listData" v-loading="loading" style="width: 1200px">
      <el-table-column prop="id" label="ID" width="65" />
      <el-table-column prop="business_name" label="Business" width="165" />
      <el-table-column prop="country" label="Country" width="110" />
      <el-table-column prop="amount" label="Amount" width="120" />
      <el-table-column prop="recipient" label="Our Recipient" width="150" />
      <el-table-column prop="receipt_reference" label="Transfer Reference" width="170" />
      <el-table-column prop="note" label="Note / Reversal Reason" width="190" />
      <el-table-column prop="system_name" label="Operator" width="120" />
      <el-table-column label="Save Time" width="170">
        <template slot-scope="scope">{{ scope.row.save_time | timestampToTime }}</template>
      </el-table-column>
      <el-table-column label="Action" width="110">
        <template slot-scope="scope">
          <el-button v-if="Number(scope.row.amount) > 0 && !scope.row.is_reversed" size="mini" type="warning"
            @click="reverse(scope.row)">Reverse</el-button>
          <span v-else-if="scope.row.reversal_of">Reverses #{{ scope.row.reversal_of }}</span>
          <span v-else>Reversed</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :child-msg="pageparm" @callFather="changePage" />
    <el-dialog title="Add Internal Recharge" :visible.sync="dialogVisible" width="500px">
      <el-form ref="rechargeForm" :model="form" :rules="rules" label-width="145px">
        <el-form-item label="Business" prop="business_id">
          <el-select v-model="form.business_id" filterable placeholder="Select business" style="width: 100%">
            <el-option v-for="business in businesses" :key="business.id" :value="business.id"
              :label="business.country + ' / ' + business.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="Amount" prop="amount">
          <el-input v-model="form.amount" placeholder="Business local currency amount" />
        </el-form-item>
        <el-form-item label="Our Recipient" prop="recipient">
          <el-input v-model="form.recipient" placeholder="Person/account that received funds" />
        </el-form-item>
        <el-form-item label="Transfer Reference" prop="receipt_reference">
          <el-input v-model="form.receipt_reference" :maxlength="180" placeholder="Unique payment evidence number" />
        </el-form-item>
        <el-form-item label="Note" prop="note"><el-input v-model="form.note" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="saving" @click="save">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { internalRechargeOptions, internalRechargeList, internalRechargeSave, internalRechargeReverse } from '../../api/apiFun'
import { timestampToTime } from '@/utils/util'
import Pagination from '../../components/Pagination'

export default {
  components: { Pagination },
  filters: { timestampToTime },
  data() {
    return {
      loading: false, saving: false, dialogVisible: false,
      businesses: [], listData: [],
      params: { page: 1, limit: 10, business_id: '' },
      pageparm: { currentPage: 1, pageSize: 10, total: 0 },
      form: { business_id: '', amount: '', recipient: '', receipt_reference: '', note: '' },
      rules: {
        business_id: [{ required: true, message: 'Select business', trigger: 'change' }],
        amount: [{ required: true, pattern: /^\d{1,16}(\.\d{1,2})?$/, message: 'Enter a positive amount (up to 2 decimals)', trigger: 'blur' }],
        recipient: [{ required: true, message: 'Enter our recipient', trigger: 'blur' }],
        receipt_reference: [{ required: true, message: 'Enter transfer reference', trigger: 'blur' }, { max: 180, message: 'Transfer reference must be at most 180 characters', trigger: 'blur' }]
      }
    }
  },
  created() {
    internalRechargeOptions().then(res => { if (res && res.code === 200) this.businesses = res.datas })
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      internalRechargeList(this.params).then(res => {
        if (res && res.code === 200) {
          this.listData = res.datas.list
          this.pageparm = { currentPage: this.params.page, pageSize: this.params.limit, total: res.datas.count }
        } else this.$message.error((res && res.msg) || 'Failed to load')
      }).catch(() => this.$message.error('Failed to load')).then(() => { this.loading = false })
    },
    search() { this.params.page = 1; this.load() },
    changePage(page) { this.params.page = page.currentPage; this.params.limit = page.pageSize; this.load() },
    openAdd() {
      this.form = { business_id: this.params.business_id || '', amount: '', recipient: '', receipt_reference: '', note: '' }
      this.dialogVisible = true
    },
    save() {
      this.$refs.rechargeForm.validate(valid => {
        if (!valid || Number(this.form.amount) <= 0) return
        const business = this.businesses.find(item => item.id === this.form.business_id)
        if (!business) return
        this.$confirm('Credit ' + business.name + ' ' + this.form.amount + ' ' + business.country + ' currency?', 'Confirm internal recharge', { type: 'warning' }).then(() => {
          this.saving = true
          internalRechargeSave(this.form).then(res => {
            if (res && res.code === 200) { this.dialogVisible = false; this.load(); this.$message.success('Saved') }
            else this.$message.error((res && res.msg) || 'Save failed')
          }).catch(() => this.$message.error('Save failed')).then(() => { this.saving = false })
        }).catch(() => {})
      })
    },
    reverse(row) {
      this.$prompt('Enter a reason. This will create an opposite entry and reduce the balance.', 'Reverse #' + row.id, {
        confirmButtonText: 'Reverse', cancelButtonText: 'Cancel', inputPattern: /\S+/, inputErrorMessage: 'Reason required'
      }).then(({ value }) => internalRechargeReverse({ id: row.id, reason: value })).then(res => {
        if (res && res.code === 200) { this.load(); this.$message.success('Reversed') }
        else this.$message.error((res && res.msg) || 'Reversal failed')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.user-search { margin-top: 20px; }
</style>



// WEBPACK FOOTER //
// src/views/business_settlement/internal_recharge.vue